export default __webpack_public_path__ + "static/media/avatar-8.865752a4.png";